<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="列表" left-text="返回" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
		<van-search class="search-box" style="margin-top: 3.2rem;" shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch" @input="onSearch"
					@cancel="onSearch" @clear="onSearch">
			<div slot="action" @click="onSearch">搜索</div>
		</van-search>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="没有更多了">
                <div v-for="item in list" class="card" :key="item.uuid" @click="openDetail(item)">
					<table class="layout" style="width: 100%" >
						<tr style="width: 100%" >
							<td colspan="4">
								<div class="header">
									<span class="title">{{item.firstNumber}}</span>
								</div>
							</td>
						</tr>
						<tr style="width: 100%" >
							<td colspan="4">
								<div class="header">
									<span class="title">{{item.secondNumber}}</span>
								</div>
							</td>
						</tr>
						<tr>
							<td colspan="2" class="content">
								<p><span>已扫码：</span><span>{{item.outNumber}}</span></p>
								<p><span>待扫码：</span><span>{{item.toOutNumber}}</span></p>
								<p><span>扫码时间：</span><span>{{item.createTime}}</span></p>
							</td>
						</tr>
					</table>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup,PullRefresh,NavBar} from 'vant';
	import barcodeService from "../../service/barcodeService";
    import {formatDictionary} from "../../utils/dictionary";
	import moment from "moment";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				value: '',
            }
        },
      
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
			[NavBar.name]: NavBar,
        },
        computed: {
            
        },
        created: async function () {
            
        },
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await barcodeService.getScanningOutputList(this.pageIndex, this.value);
                resp.data.Data.data.forEach(item => {
                    item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm');
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
                console.log(this.list)
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			onSearch() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
            openDetail(item){
				this.$router.push({path:"outputDetails",query:{uuid:item.outputIds, scanningOutputId: item.uuid}})
            },
			onClickLeft(){
				 this.$router.go(-1);
			}
        }
    };

</script>
<style>
	.listBox{
		margin-top: 0;
	}
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
</style>